import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/system.css';
import './styles/office.css';
import './styles/scan.css';
import './styles/wall.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Only the phone app is installable and works offline; the office runs online in a browser tab,
// so it should never pick up a service worker. In dev there is no built /sw.js to register.
if (!import.meta.env.DEV && location.pathname.startsWith('/scan') && 'serviceWorker' in navigator) {
  void navigator.serviceWorker.register('/sw.js').catch(() => undefined);
}
